export default function MentionsLegales() {
  return (
    <section className="legal-content container-narrow">
      <span className="eyebrow">Informations</span>

      <h1>Mentions légales</h1>

      <h2>Éditeur du site</h2>
      <p>
        Vague de Mots — activité indépendante de lecture,
        d'analyse et de correction de textes.
      </p>
      <p>
        Nom commercial : Vague de Mots<br />
        Statut : Entrepreneur individuel (micro-entreprise)<br />
        SIREN : 907 716 260<br />
        Identité de l'entrepreneuse : à compléter<br />
        Adresse professionnelle : à compléter<br />
        Téléphone : à compléter<br />
        E-mail : <a href="mailto:contact@vaguedemots.fr">
          contact@vaguedemots.fr
        </a>
      </p>

      <h2>Hébergement</h2>
      <p>
        OVH SAS<br />
        2 rue Kellermann<br />
        59100 Roubaix — France<br />
        SIREN : 424 761 419<br />
        Site : <a href="https://www.ovhcloud.com"
          target="_blank" rel="noopener noreferrer">
          www.ovhcloud.com
        </a>
      </p>

      <h2>Infogérance et maintenance technique</h2>
      <p>
        L'administration de l'infrastructure, l'infogérance,
        la maintenance et la supervision technique du site
        sont assurées par NOVEANCE.
      </p>
      <p>
        Site : <a href="https://www.noveance.fr"
          target="_blank" rel="noopener noreferrer">
          www.noveance.fr
        </a><br />
        Contact : <a href="mailto:contact@noveance.fr">
          contact@noveance.fr
        </a>
      </p>

      <h2>Propriété intellectuelle</h2>
      <p>
        Les textes, photographies, illustrations et autres
        contenus présents sur ce site sont protégés par
        les dispositions applicables en matière de propriété
        intellectuelle, sous réserve des droits de leurs
        titulaires respectifs.
      </p>
      <p>
        Toute reproduction ou utilisation non autorisée
        d'un contenu protégé est susceptible de porter
        atteinte aux droits de son titulaire.
      </p>

      <h2>Responsabilité</h2>
      <p>
        Vague de Mots veille à fournir des informations
        exactes et actualisées concernant ses prestations.
        Ces informations peuvent évoluer.
      </p>

      <h2>Données personnelles</h2>
      <p>
        Pour toute information concernant le traitement
        de vos données personnelles, consultez notre
        <a href="/politique-de-confidentialite">
          {' '}politique de confidentialité
        </a>.
      </p>
    </section>
  );
}
